import { socket } from '../..';
import { store } from '@shared/redux';
import { generatedApi } from '@shared/api';

export const handleKnowledgeStatus = () => {
  return socket.onMessage('KNOWLEDGE_STATUS', (payload) => {
    const knowledgeBaseId = payload.knowledge_base_id;
    const status = payload.status;

    if (typeof knowledgeBaseId !== 'number') return;

    const cachedKnowledgeListArgs = generatedApi.util.selectCachedArgsForQuery(
      store.getState(),
      'getKnowledgeListKnowledgeListGet',
    );

    cachedKnowledgeListArgs?.forEach((args) => {
      store.dispatch(
        generatedApi.util.updateQueryData('getKnowledgeListKnowledgeListGet', args, (draft) => {
          const item = draft.find((knowledgeBase) => knowledgeBase.id === knowledgeBaseId);
          if (item) {
            item.status = status;
          }
        }),
      );
    });
  });
};
